import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  compact?: boolean;
}

export default function MovieCard({ movie, compact = false }: MovieCardProps) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={movie.poster}
          alt={`${movie.title} 电影海报`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 font-label text-xs font-bold text-foreground-950">
          <i className="ri-star-fill text-[11px]" aria-hidden="true" />
          {movie.rating.toFixed(1)}
        </span>
        <span className="absolute right-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 font-label text-[11px] font-medium text-background-50 backdrop-blur-sm">
          {movie.genre}
        </span>
      </div>
      <div className={`flex flex-1 flex-col gap-1.5 ${compact ? 'p-2.5' : 'p-3.5'}`}>
        <h3
          className={`font-heading font-bold text-foreground-950 leading-snug ${
            compact ? 'text-sm' : 'text-base md:text-lg'
          }`}
        >
          {movie.title}
        </h3>
        <p className="font-label text-xs text-foreground-500">
          {movie.year} · {movie.region} · {movie.duration}
        </p>
        {!compact ? (
          <p className="mt-1 line-clamp-2 text-xs md:text-sm leading-relaxed text-foreground-600">{movie.blurb}</p>
        ) : null}
      </div>
    </article>
  );
}